export default ({ app, $api, store }) => {
  $api.register('client', '/web', request => ({
    create(payload) {
      return request('POST', '/public/client', {
        language: app.i18n.locale,
        ...payload,
      });
    },
    update(payload) {
      return request('PUT', '/private/client', payload);
    },
    getClientJourneyStep() {
      return request('GET', '/private/client/client-journey/current');
    },
    completeBackOfficeClient(payload) {
      return request('PUT', '/private/client/complete-back-office-client', payload);
    },
    completeStepTwo(payload) {
      return request('PUT', '/private/client/complete-step-two', payload);
    },
    completeStepThree(payload) {
      return request('PUT', '/private/client/complete-step-three', payload);
    },
    completeStepFour(payload) {
      return request('PUT', '/private/client/complete-step-four', payload);
    },
    recover(payload) {
      return request('POST', '/public/client/recover/password', payload);
    },
    changePassword(payload) {
      return request('POST', '/private/client/change/password', payload);
    },
    changePhone(payload) {
      return request('PUT', '/private/client/change/phone', payload);
    },
    changeEmail(payload) {
      return request('PUT', '/private/client/change/email', payload);
    },
    addContact(payload) {
      return request('POST', '/private/client/additional/contact', payload);
    },
    updateLimit() {
      return request('PUT', '/private/client/yhat/limit');
    },
    find({ key, value }) {
      return request('GET', `/public/client/check/${key}/${value}`);
    },
    sendSms(number, type, otherParams = {}) {
      return request('POST', `/public/client/phone/sms-code${type ? `-${type}` : ''}`, {
        mobilePhone: { number },
        ...otherParams,
      });
    },
    sendPrivateSms() {
      return request('POST', '/private/client/phone/sms-code');
    },
    verifyPrivateSms(payload) {
      return request('POST', '/private/client/phone/verify', payload);
    },
    verifyTsCode(payload) {
      return request('POST', '/private/client/phone/verify-ts', payload);
    },
    resendTsCode() {
      return request('POST', '/private/client/phone/sms-code-ts');
    },
    verifyIban(iban) {
      return request('PUT', '/private/client/iban/validate', { iban });
    },
    sendEmail(email) {
      return request('POST', '/public/client/email/send-code', { email });
    },
    createApplication(payload) {
      return request('POST', '/private/client/application', payload);
    },
    updateApplication({ id, payload }) {
      return request('PUT', `/private/client/application/${id}`, payload);
    },
    captureBehaviour(page, payload) {
      return request('POST', '/private/client/logger/metrics', {
        [page]: payload,
      });
    },
    getApplication() {
      return request('GET', '/private/client/application/actual');
    },
    getApplicationStatus() {
      return request('GET', '/private/client/application/actual/status');
    },
    getApplicationOffer(id = store.state.client.application.id) {
      return request('GET', `/private/client/application/${id}/offer/actual`);
    },
    approveSpecialDecrease() {
      return request('PUT', `/private/client/special/offer/approve`);
    },
    approveYhatDecrease() {
      return request('PUT', `/private/client/yhat/offer/approve/decrease`);
    },
    approveIncrease(payload) {
      return request('PUT', '/private/client/yhat/offer/approve/increase', payload);
    },
    getLoan() {
      return request('GET', '/private/client/loan/active');
    },
    triggerEmailSending(payload) {
      return request('PUT', '/private/client/loan/active/rollover', payload);
    },
    generateDetails(payload, client = false, id = 'terms_and_conditions_anonymous') {
      const path = client ? '/private/client/render/document' : '/public/client/document';

      return request('POST', path, {
        financeType: 'stl',
        id,
        ...payload,
      });
    },
    availableDocuments() {
      return request('GET', '/private/client/document');
    },
    async downloadDocument({ type, name = type }) {
      const { success, response } = await request(
        'GET',
        `/private/client/document/download/${type}`,
        {
          responseType: 'arraybuffer',
        }
      );

      if (success) app.$tools.downloadFile(response, name);
    },
    uploadDocument(payload) {
      return request('POST', '/private/client/document/upload', payload);
    },
    uploadIncomeDetails(payload) {
      return request('POST', '/private/client/bank-statement/upload', payload);
    },
    finishFlow() {
      return request('PUT', '/private/client/finish');
    },
    saveGeoLocation(payload) {
      return request('POST', '/private/client/geo', payload);
    },
    saveDisbursementType(payload) {
      return request('POST', '/private/client/disbursement-type', payload);
    },
    saveSummaryConsent({ id, payload }) {
      return request('POST', `/private/client/application/agreement/${id}`, payload);
    },
    getRoute() {
      return request('GET', '/private/client/flow');
    },
    payoutReferral(id) {
      return request('PATCH', `/private/client/referrals/${id}`);
    },
    getReferrals() {
      return request('GET', '/private/client/referrals');
    },
    addReferral(payload) {
      return request('POST', '/private/client/referrals', payload);
    },
    getActivePaymentSchedule() {
      return request('GET', '/private/client/loan/active/payment-schedule');
    },
    createRolloverApplication(loanId, rolloverId) {
      return request('POST', `/private/client/loan/${loanId}/rollover/${rolloverId}/application`);
    },
    uploadRolloverDocument(loanId, rolloverId, applicationId, payload) {
      return request(
        'POST',
        `/private/client/loan/${loanId}/rollover/${rolloverId}/application/${applicationId}/document`,
        payload
      );
    },
    getApplicationPaymentMethod() {
      return request('GET', '/private/client/application/payment-method');
    },
  }));
};
